import { memo, useMemo, type PropsWithChildren } from 'react';

import { useAuth } from '@/js/libs/use-auth';

import { Authorization } from './containers/Authorization/index.tsx';
import { AuthContext } from './context.ts';
import { useAxiosIntegration, useRequestHeaders } from './hooks/index.ts';

// Sends the token with every request, and authorizes the user of the token once there is one.
export const AuthContextProvider = memo(function AuthContextProvider({ children }: PropsWithChildren) {
  const { token } = useAuth();
  const headers = useRequestHeaders();
  const value = useMemo(() => ({ headers }), [headers]);

  useAxiosIntegration({ headers });

  return <AuthContext.Provider value={value}>{token ? <Authorization>{children}</Authorization> : children}</AuthContext.Provider>;
});
